import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from 'react';
import { CustomNavigate } from '@/components/functional/Link/CustomNavigate/CustomNavigate';
import { CustomRoute } from '@/components/functional/Link/CustomRoute';
import { CustomRoutes } from '@/components/functional/Link/CustomRoutes';
import { ContactOther } from '@/pages/contact/other/ContactOther';
import { ContactOtherComplete } from '@/pages/contact/other/ContactOtherComplete';
import { ContactOtherConfirm } from '@/pages/contact/other/ContactOtherConfirm';
import { CONTACT_MAIN_OTHER_TYPES } from '@/utils/constants/contact/contactMain/contactTypes';
import { pagePath, getChildPath } from '@/utils/router/pagePath';
const contactPath = pagePath.contact;
const rootPath = pagePath.contact.otherRoot();
/**
 * その他のお問い合わせのアクセスルーティング用
 */
export const ContactOtherRoot = () => {
    const [formState, changeFormState] = useState(null);
    const resetFormState = useCallback(() => {
        changeFormState(null);
    }, [changeFormState]);
    const types = CONTACT_MAIN_OTHER_TYPES;
    return (_jsxs(CustomRoutes, { children: [_jsx(CustomRoute, { element: _jsx(ContactOther, { changeFormState: changeFormState, formState: formState, types: types }), path: getChildPath(contactPath.other(), rootPath) }), _jsx(CustomRoute, { element: _jsx(ContactOtherConfirm, { formState: formState, types: types }), path: getChildPath(contactPath.otherConfirm(), rootPath) }), _jsx(CustomRoute, { element: _jsx(ContactOtherComplete, { resetFormState: resetFormState }), path: getChildPath(contactPath.otherComplete(), rootPath) }), _jsx(CustomRoute, { element: _jsx(CustomNavigate, { to: pagePath.notfound() }), path: '*' })] }));
};
